
// Define action constants
module.exports = {
  RECEIVE_DATA : 4,
  UPDATE_SERVICE: 5,
  EDIT_MESSAGE: 6,
  DELETE_MESSAGE: 7
};


/** WEBPACK FOOTER **
 ** ./src/constants/StateConstants.js
 **/